import { Observable } from 'rxjs';
export abstract class IContext {
    public readonly $contactInfo: Observable<IContextContactInfo | undefined>;
}

export interface IContextContactInfo {
    name: string;
    email: string;
}
